import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

const listaTipoCompra = [
    { value: null, label: 'Nenhum' },
    { value: 1, label: 'Empenho' },
    { value: 2, label: 'Ata de Registro de Preço' },
    { value: 3, label: 'Contrato' },
    { value: 4, label: 'Convênio' },
]

/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    removeAdministracaoConsultaEmpenhoCredorAquisicoesDiretas: ['administracao'],
    removeExercicioEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioEmpenhoInicial'],
    removeExercicioEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioEmpenhoFinal'],
    removeNumeroEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['numeroEmpenhoInicial'],
    removeNumeroEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['numeroEmpenhoFinal'],
    removeDataEmpenhoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['dataEmpenhoInicial'],
    removeDataEmpenhoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['dataEmpenhoFinal'],
    removeDataVencimentoInicialConsultaEmpenhoCredorAquisicoesDiretas: ['dataVencimentoInicial'],
    removeDataVencimentoFinalConsultaEmpenhoCredorAquisicoesDiretas: ['dataVencimentoFinal'],
    removePagosConsultaEmpenhoCredorAquisicoesDiretas: ['pagos'],
    removeRecursoConsultaEmpenhoCredorAquisicoesDiretas: ['recurso'],
    removeDestinacaoConsultaEmpenhoCredorAquisicoesDiretas: ['destinacao'],
    removeNomeCredorConsultaEmpenhoCredorAquisicoesDiretas: ['nomeCredor'],
    removeCnpjConsultaEmpenhoCredorAquisicoesDiretas: ['cnpj'],
    removeCpfConsultaEmpenhoCredorAquisicoesDiretas: ['cpf'],
    removeDocumentoConsultaEmpenhoCredorAquisicoesDiretas: ['documento'],
    removeExercicioProtocoloInicialConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioProtocoloInicial'],
    removeExercicioProtocoloFinalConsultaEmpenhoCredorAquisicoesDiretas: ['exercicioProtocoloFinal'],
    removeNumeroProtocoloInicialConsultaEmpenhoCredorAquisicoesDiretas: ['numeroProtocoloInicial'],
    removeNumeroProtocoloFinalConsultaEmpenhoCredorAquisicoesDiretas: ['numeroProtocoloFinal'],
    removeProcessoReferenciaConsultaEmpenhoCredorAquisicoesDiretas: ['processoReferencia'],
    removeTipoCompraConsultaEmpenhoCredorAquisicoesDiretas: ['tipoCompra'],
    removeBaseLegalConsultaEmpenhoCredorAquisicoesDiretas: ['baseLegal'],
    setMostraAplicarFiltroConsultaEmpenhoCredorAquisicoesDiretas: [],
    limpaFiltroConsultaEmpenhoCredorAquisicoesDiretas: [],
    aplicarFiltroConsultaEmpenhoCredorAquisicoesDiretas: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioEmpenhoInicial: '',
    exercicioEmpenhoFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    recurso: [],
    destinacao: [],
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    documento: '',
    exercicioProtocoloInicial: '',
    exercicioProtocoloFinal: '',
    numeroProtocoloInicial: '',
    numeroProtocoloFinal: '',
    processoReferencia: '',
    tipoCompra: { value: listaTipoCompra[0].value, label: listaTipoCompra[0].label },
    baseLegal: [],
    mostraAplicarFiltro: false,
}
const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeExercicioEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: '', mostraAplicarFiltro: true }
}
const removePagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const removeDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: '', mostraAplicarFiltro: true }
}

const removeExercicioProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloFinal: '', mostraAplicarFiltro: true }
}
const removeProcessoReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, processoReferencia: '', mostraAplicarFiltro: true }
}
const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}
const removeBaseLegal = (state = INITIAL_STATE, action) => {
    state.baseLegal.splice(state.baseLegal.indexOf(action.baseLegal), 1)
    state.baseLegal = Array.from(state.baseLegal)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeAdministracao,
    [Types.REMOVE_EXERCICIO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeExercicioEmpenhoInicial,
    [Types.REMOVE_EXERCICIO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeExercicioEmpenhoFinal,
    [Types.REMOVE_NUMERO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeNumeroEmpenhoInicial,
    [Types.REMOVE_NUMERO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeNumeroEmpenhoFinal,
    [Types.REMOVE_DATA_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDataEmpenhoInicial,
    [Types.REMOVE_DATA_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDataEmpenhoFinal,
    [Types.REMOVE_DATA_VENCIMENTO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDataVencimentoInicial,
    [Types.REMOVE_DATA_VENCIMENTO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDataVencimentoFinal,
    [Types.REMOVE_PAGOS_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removePagos,
    [Types.REMOVE_RECURSO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDestinacao,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeCpf,
    [Types.REMOVE_DOCUMENTO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeDocumento,
    [Types.REMOVE_EXERCICIO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeExercicioProtocoloInicial,
    [Types.REMOVE_EXERCICIO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeExercicioProtocoloFinal,
    [Types.REMOVE_NUMERO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeNumeroProtocoloInicial,
    [Types.REMOVE_NUMERO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeNumeroProtocoloFinal,
    [Types.REMOVE_PROCESSO_REFERENCIA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeProcessoReferencia,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeTipoCompra,
    [Types.REMOVE_BASE_LEGAL_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: removeBaseLegal,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_EMPENHO_CREDOR_AQUISICOES_DIRETAS]: aplicarFiltro,
})
